module.exports = __webpack_public_path__ + "img/logoUni_ParisCite.bcb633a8.png";